import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { trashOutline } from 'ionicons/icons';
import './style.css';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { deleteWorkOrderAttachmentAsync, getAllAttachmentsByWorkorderIdAsync, updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { formatDMY, handleRolePermission } from '@infrastructure/helpers';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import ModalPopup from '@ui/components/VnModal';
import AttachmentPreviewModal from '@ui/components/VnAttachmentPreviewModal';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { VisserModule } from '@application/common/enums/visser-module';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
const AttachemnetTable = ({ formData, updateGridCheck, isAttachmentTabBold }) => {
    // const warningMessageRef = useRef<{ resetTimer: () => void } | null>(null);
    const { workOrderAttachments } = useAppSelector((state) => state.workorder);
    const dispatch = useAppDispatch();
    const [isupdated, setIsupdated] = useState(false);
    const [isDeleteConformOpen, setIsDeleteConformOpen] = useState(false);
    const [selectedAttachmentId, setSelectedAttachmentId] = useState(0);
    const [isAttachmentPreviewOpen, setIsAttachmentPreviewOpen] = useState(false);
    const [attachmentSrc, setAttachmentSrc] = useState('');
    const [isPersistantInfoCustomToasterOpen, setIsPersistantInfoCustomToasterOpen] = useState(false);
    useEffect(() => {
        if (formData.id > 0) {
            dispatch(getAllAttachmentsByWorkorderIdAsync(formData.id))
                .unwrap()
                .then((res) => {
                if (isAttachmentTabBold && res.length > 0) {
                    isAttachmentTabBold(true);
                }
                else {
                    isAttachmentTabBold && isAttachmentTabBold(false);
                }
            });
        }
    }, [dispatch, formData.id, isupdated]);
    useEffect(() => {
        setIsupdated((prev) => !prev);
    }, [updateGridCheck]);
    const imageType = (fileExtension) => {
        if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
            return 'png-icon.png';
        }
        else if (fileExtension === 'pdf') {
            return 'pdf-icon.png';
        }
        else if (fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv') {
            return 'csv-icon.png';
        }
        return 'png-icon.png';
    };
    const deleteWorkOrderAttachment = async (attachmentId) => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsDeleteConformOpen(true);
            setSelectedAttachmentId(attachmentId);
        }
    };
    function onCancelDeleteClicked() {
        setIsDeleteConformOpen(false);
    }
    async function onDeleteClicked() {
        if (selectedAttachmentId > 0) {
            dispatch(deleteWorkOrderAttachmentAsync(selectedAttachmentId))
                .unwrap()
                .then((res) => {
                setIsDeleteConformOpen(false);
                setIsupdated(!isupdated);
                setSelectedAttachmentId(0);
            });
        }
    }
    function onRowClick(attachmentId) {
        if (workOrderAttachments) {
            const attachment = workOrderAttachments.find((attachment) => attachment.id === attachmentId);
            if (attachment) {
                const fileExtension = attachment.fileName.substring(attachment.fileName.lastIndexOf('.') + 1).toLocaleLowerCase();
                if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
                    setIsAttachmentPreviewOpen(true);
                    setAttachmentSrc('data:image/jpeg;base64,' + attachment.document);
                }
                else if (fileExtension === 'png') {
                    setIsAttachmentPreviewOpen(true);
                    setAttachmentSrc('data:image/png;base64,' + attachment.document);
                }
                else if (fileExtension === 'pdf') {
                    setIsAttachmentPreviewOpen(true);
                    setAttachmentSrc('data:application/pdf;base64,' + attachment.document);
                }
                else if (fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv') {
                    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${attachment.document}`;
                    const downloadLink = document.createElement('a');
                    const fileName = attachment.fileName;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            }
        }
    }
    const oncloseClicked = () => {
        setIsAttachmentPreviewOpen(false);
    };
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        if (formData.id) {
            dispatch(resetTimer());
            // if (warningMessageRef.current) {
            //     warningMessageRef.current.resetTimer();
            // }
            var moduleLockRequestData = {
                moduleId: VisserModule.Werkorder,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table align-middle', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", {}), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestandsnaam" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Aangemaakt" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestandstype" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: workOrderAttachments &&
                                        workOrderAttachments?.map((attachment) => (_jsxs("tr", { style: { cursor: 'pointer' }, onClick: () => {
                                                onRowClick(attachment.id);
                                            }, children: [_jsx("td", { children: _jsx(VnButton, { type: 'button', mode: 'danger', size: 'sm', customClassName: 'Vn-grid-delete-button', icon: trashOutline, onClick: (event) => {
                                                            event.stopPropagation();
                                                            if (handleRolePermission(Permission.WBIJLAGEN, PermissionType.Delete)) {
                                                                deleteWorkOrderAttachment(attachment.id);
                                                            }
                                                        } }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: attachment.fileName.substring(0, attachment.fileName.lastIndexOf('.')) }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: formatDMY(attachment?.created.toString()) }) }), _jsx("td", { className: 'pt-4', children: attachment.fileName && (_jsxs("span", { children: [attachment.fileName.toLowerCase().split('.').pop()?.toUpperCase(), " File"] })) })] }, attachment.id))) })] }) }) }) }), _jsx(VnConfirmationModel, { title: 'Wilt u deze bijlage verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isDeleteConformOpen }), _jsx(ModalPopup, { content: _jsx(AttachmentPreviewModal, { attachmentSrc: attachmentSrc, onClose: () => oncloseClicked() }), onOpen: isAttachmentPreviewOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachemnetTable;
